export default {
  title: "Autorización {id}",
  createdAt: "Fecha de creación",
  beneficiary: "Asegurado/a",
  memberCode: "Carnet",
  sponsor: "Aseguradora",
  coverage: "Cobertura",
  settlementId: "ID Radicación",
  doctor: "Médico",
  specialty: "Especialidad",
  licenseNumber: "Licencia médica",
  branch: "Centro médico",
  productName: "Tipo de consulta",
  additionalDocuments: "Documentos adicionales",
  supportDocuments: "Documentos generales",
  requiereDocuments: "Documentos requeridos",
  optionalDocuments: "Documentos opcionales",
  claim: "Reclamo",
  authorization: "Autorización",
  documentation: {
    label: "Documentación",
    incomplete: "Incompleta (Docs {uploaded}/{total})",
    complete: "Completa",
    require: "(Requerido)"
  },
  attachDialog: {
    attachFiles: "Adjuntar archivos",
    additionalFiles: "Documentos adicionales (opcional)",
    fileFormats: "Archivos en formato PDF, PNG, JPEG, XML hasta 10Mb",
    addFileDescription: "Adjunta otros documentos que consideres necesarios y relevantes para la autorización"
  },
  buttons: {
    back: "Regresar",
    attachDocument: "Adjuntar",
    addDocument: "Agregar",
    replace: 'Reemplazar'
  },
  emptyState: {
    documents: "No se encontraron documentos adicionales",
    noResults: "No se encontraron datos",
    noResultsDescription: "No se encontró el reclamo de consulta médica deseado."
  },
  preview: {
    title: "Vista previa",
    label: "Este archivo no tiene vista previa.",
    actions: {
      cancel: "Cancelar",
      download: "Descargar",
      delete: "Eliminar"
    }
  },
  diagnoses: {
    title: "Diagnóstico(s)",
    headers: {
      diagnosisCode: "Código CIE - 10",
      diagnosisName: "Nombre",
      status: "Estado"
    },
    status: {
      approved: "Aprobado",
      rejected: "Rechazado",
      manualApprovalRequired: "Revisión manual requerida"
    }
  },
  treatments: {
    title: 'Tratamientos prescritos',
    headers: {
      name: 'Medicamento',
      treatment: 'Tratamiento'
    }
  },
  products: {
    title: "Información de reclamos",
    headers: {
      productNames: {
        drugs: "Medicamento",
        diagnosticTests: "Laboratorios",
        medicalProcedures: "Procedimiento"
      },
      productName: "Medicamento",
      price: "Precio Unitario",
      refill: "Refil",
      refillValues: "{refillNumber} de {numberOfRefills}",
      quantity: "Cantidad",
      status: "Estado",
      claim: "Reclamo"
    },
    status: {
      approved: "Aprobado",
      rejected: "Rechazado",
      claimed: "Reclamado",
      manualApprovalRequired: "Revisión manual requerida",
      partiallyClaimed: "Parcialmente reclamada"
    }
  },
  void: "Anular autorización",
  voidOnlyClaim: "Anular reclamo",
  detailV2: {
    authorization: "Autorización",
    createdAt: "Fecha de creación",
    newAssessment: "Nueva valoración",
    patientDischarge: "Egreso del paciente",
    addInvoice: "Enviar factura",
    files: "Formatos de aseguradora",
    tabs: {
      information: "Información",
      documentation: "Documentación",
      observations: "Observaciones",
    },
    beneficiary: {
      coverage: "Cobertura",
      insured: "Asegurado/a",
      identification: "Identificación",
      sponsor: "Aseguradora",
      label: 'El beneficiario',
      inactive: "se encuentra inactivo",
      and: "y",
      noBenefitAvailable: "no cumple con el monto mínimo asegurado",
      maximumBenefitAvailable: 'Disponible {0}'
    },
    doctor: {
      physician: "Médico",
      specialty: "Especialidad",
      license: "Licencia",
    },
    observations: {
      empty: "No hay observaciones",
      today: "Hoy {date}",
      addComment: "Escriba su comentario",
    },
    addPreInvoiceDialog: {
      title: "Egreso del paciente",
      subtitle: "Adjunte el documento de la pre-cuenta para dar egreso al paciente",
      sectionTitle: "Documento"
    },
    addInvoiceDialog: {
      title: "Enviar factura",
      subtitle: "Adjunte la factura en los formatos requeridos para continuar.",
      sectionXmlTitle: "Factura (XML)",
      sectionPdfTitle: "Factura (PDF)"
    },
    documentation: {
      search: 'Buscar',
      type: 'Tipo de soporte',
      fileName: 'Nombre del archivo',
      required: 'Requerido',
      actions: 'Acciones',
      addDocument: 'Agregar documento',
      yes: 'Si',
      no: 'No',
      downloadSuccess: 'Descarga exitosa',
      replaceSuccess: 'Reemplazo exitoso',
      deleteSuccess: 'Eliminación exitosa',
      deleteFileMessage: "¿Está seguro de que desea eliminar el archivo seleccionado?",
      deleteFileConfirmation: "Esta acción no se puede deshacer",
      createdAt: "Fecha de carga"
    },
    uploadFiles: {
      title: "Agregar documentos",
      selectDocumentType: "Selecciona el tipo de documento",
      addDocumentsButton: "Agregar documentos",
      uploadButton: "Finalizar y cerrar",
      cancelMessage: "¿Está seguro de que desea cancelar la carga de documentos?",
      lostInformationMessage: "La selección de documentos se perderá",
      maxFilesLimit: "Solo es posible seleccionar hasta {maxFiles} archivos",
      maxFileLimit: "Solo es posible seleccionar hasta {maxFiles} archivo",
      maxFilesLimitByType: "Solo es posible seleccionar hasta {maxFiles} archivos por tipo.",
      maxSizeError: "El o los siguientes archivo(s) exceden el tamaño máximo permitido ({maxSize} MB): {files}",
      numberHeader: "No.",
      fileTypeHeader: "Tipo de documento",
      fileNameHeader: "Nombre del archivo",
      actionsHeader: "Acciones"
    }
  }
}
